import React from 'react'
import { Row, Col, Avatar } from 'antd';
import {
  UserOutlined,
  GithubOutlined,
  QqOutlined,
  WeiboOutlined,
  ZhihuOutlined,
  WechatOutlined,
  TwitterOutlined,
  MailOutlined
} from '@ant-design/icons';

const SidePersonComponent = function () {
  return (
    <Row gutter={18}>
      <Col span={24}>
        <div className="teji-container">
          <div className="teji-wrapper">
            {
              [
                { url: 'images/bg1.jpg', name: '悬崖之上' },
                { url: 'images/bg2.jpeg', name: '生活与美食' },
                { url: 'images/bg3.jpeg', name: '远方的风景' }
              ].map(item => {
                return (
                  <div className="teji-item" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${item.url})` }}>
                    <div className="item-name">专题 | {item.name}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </Col>
    </Row>
  )
}
export default SidePersonComponent